<template>
  <Fragment>
    <div class="wrap" :style="`display: ${display}`">
      <div class="tip">{{ $t('Gattaran_Homepage__anfP' /** 点击可查看功能模块对应的角色列表 */) }}</div>
      <pb-button class="pb-button" type="primary" size="mini" @click="cancel()">{{ $t('Gattaran_Homepage__FxHz' /** 我知道了 */) }}</pb-button>
      <div class="arrow"></div>
    </div>
  </Fragment>
</template>

<script>
export default {
  data() {
    return {
      display: 'flex',
    };
  },
  mounted() {
    // 如果引导出现过，则隐藏
    if (localStorage.getItem('GTR_INSTRUCTION_FLAG')) {
      this.display = 'none';
    } else {
      // 第一次则展示引导
      localStorage.setItem('GTR_INSTRUCTION_FLAG', new Date().toDateString());
    }
  },
  methods: {
    // 取消关闭引导
    cancel() {
      this.display = 'none';
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  background: #282b33;
  box-shadow: 0 3px 8px 0 rgba(3, 4, 5, 0.08);
  border-radius: 4px;
  position: absolute;
  top: 50px;
  right: 24px;
  padding: 10px 16px;
  z-index: 999;
  display: flex;
  flex-direction: row;
  .tip {
    margin-right: 40px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #ffffff;
    line-height: 24px;
    font-weight: 400;
  }
  .pb-button {
    height: 28px;
  }
}
.arrow {
  width: 8px;
  height: 8px;
  background: #282b33;
  transform: rotate(45deg);
  position: absolute;
  top: -4px;
  right: 32px;
}
</style>
